import { combineReducers } from "redux";
import { reducer as taskNoteReducer } from "../reducers/taskNote";
import { reducer as workflowReducer } from "../reducers/workflow";

export default combineReducers({
  workflowDetails: workflowReducer,
  taskNote: taskNoteReducer,
});
